import { PagingInfo } from "../../../utils/Grid";
import { acquireAccessToken } from "../../../index";
import axios from "axios";
import {HoldFlagFetchSearchCriteria} from "./HoldsFlag";

export interface CriteriaAndPaging {
    criteria?: HoldFlagFetchSearchCriteria,
    paging?: PagingInfo,
}

export async function fetchAll(query: CriteriaAndPaging) {
    const token = await acquireAccessToken();
    return await axios.get('/api/HoldFlags', {
        headers: {
            authorization: `Bearer ${token}`,
        },
        params: { ...query.criteria, ...query.paging },
    });
}
